import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SchoolCourses, SchoolLesson } from '@digilize/language-school/definitions';

@Injectable({
  providedIn: 'root',
})
export class SchoolLessonsApiService {
  constructor(private http: HttpClient) {}

  getLesson = (lessonId: string) => this.http.get<SchoolLesson>(`/api/v1.0/school-lessons/${lessonId}`);
  setLessonOpened = (lessonId: string) =>
    this.http.post<SchoolCourses>(
      `/api/v1.0/school-lessons/${lessonId}/report/opened`,
      null
    ); /* sets lesson to completed and adjust elements containing this lesson if conditions are met */
}
